/* @flow */
import Group from 'entities/Group';
import ArchivedClassesListItem from './ArchivedClassesListItem.jsx';
import React from 'react';

import './styles/ArchivedClassesList.scss';

export default class ArchivedClassesList extends React.Component {

  props: {
    archivedClasses: Group[],
    canCreateGroups: bool,
  };

  renderArchivedClassesList() {
    const { canCreateGroups } = this.props;

    if (this.props.archivedClasses.length > 0) {
      return this.props.archivedClasses.map((archivedClass) => {
        return (
          <ArchivedClassesListItem
            archivedClass={archivedClass}
            key={archivedClass.id}
            canCreateGroups={canCreateGroups}
          />
        );
      });
    } else {
      return this.renderNoArchivedClasses();
    }
  }

  renderNoArchivedClasses() {
    return (
      <div className="ArchivedClassesList-noClasses">
        No archived classes.
      </div>
    );
  }

  render() {
    return (
      <div className="ArchivedClassesList-table">
        {this.renderArchivedClassesList()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/settings/components/ArchivedClassesList.jsx